import { getAsset } from "./assets";

function requireMovieGachaAsset(id: string) {
  const path = getAsset(id, "movie-gacha-v1")?.path;

  if (!path) {
    throw new Error(`Missing movie gacha asset: ${id}`);
  }

  return path;
}

const INCEPTION_GACHA_ART = requireMovieGachaAsset("movie-gacha-inception-art");

export interface MovieGachaCandidate {
  id: string;
  title: string;
  subtitle: string;
  badge: string;
  imageSrc: string;
  recommendation: string;
  capsuleTone: "cyan" | "violet" | "amber" | "coral" | "mint" | "blue" | "rose";
}

export const MOVIE_GACHA_CANDIDATES: MovieGachaCandidate[] = [
  {
    id: "dune-three",
    title: "沙丘3",
    subtitle: "科幻冒险 · 4 分钟速看",
    badge: "新上线",
    imageSrc: "assets/figma/night-ai/video-companion/dune-four-cast.webp",
    recommendation: "世界观够大，节奏又紧凑。今晚想看点有分量的，它正合适。",
    capsuleTone: "amber"
  },
  {
    id: "grandma-letter",
    title: "给阿嬷的情书",
    subtitle: "剧情爱情 · 温情推荐",
    badge: "口碑佳作",
    imageSrc: "assets/figma/night-ai/video-companion/grandma-letter-still.webp",
    recommendation: "想看一部温柔、能慢慢沉进去的电影，今晚就选它。",
    capsuleTone: "rose"
  },
  {
    id: "wandering-earth",
    title: "流浪地球",
    subtitle: "中国科幻 · 3 分钟速看",
    badge: "高能科幻",
    imageSrc: "assets/figma/night-ai/video-companion/wandering-earth-still.webp",
    recommendation: "场面够燃，故事也有分量，适合现在来一点提神的科幻。",
    capsuleTone: "coral"
  },
  {
    id: "world-cup",
    title: "世界杯焦点战",
    subtitle: "巴西 VS 日本 · 赛事回看",
    badge: "正在热播",
    imageSrc: "assets/figma/night-ai/video-companion/world-cup-brazil-japan-still.webp",
    recommendation: "不想费脑又想有点紧张感，这场焦点战正好接得住。",
    capsuleTone: "mint"
  },
  {
    id: "crossroads",
    title: "罗永浩的十字路口",
    subtitle: "深度访谈 · 继续观看",
    badge: "上次看到",
    imageSrc: "assets/figma/night-ai/video-companion/crossroads-two-person.webp",
    recommendation: "想听点有信息量的长谈，就从上次的位置继续，不用重新进入状态。",
    capsuleTone: "cyan"
  },
  {
    id: "interstellar",
    title: "星际穿越",
    subtitle: "科幻冒险 · 169 分钟",
    badge: "经典重温",
    imageSrc: "assets/figma/night-ai/video-companion/interstellar-trailer.webp",
    recommendation: "今晚适合一部能真正沉浸进去的电影，宇宙、亲情和时间一次看够。",
    capsuleTone: "blue"
  },
  {
    id: "inception",
    title: "盗梦空间",
    subtitle: "科幻悬疑 · 148 分钟",
    badge: "脑洞之选",
    imageSrc: INCEPTION_GACHA_ART,
    recommendation: "想来点烧脑又利落的，层层梦境会让今晚更有意思。",
    capsuleTone: "violet"
  }
];

export const MOVIE_GACHA_DEFAULT_RESULT_INDEX = 5;
